export default "__VITE_ASSET__$R6NPZIN__"